import { Box } from '@pocketlaw/tetris';
import { getSearchEntityLink } from 'app/domains/global-search/utils/getSearchEntityLink';
import { Date } from './Date';
import { EntityIcon } from './EntityIcon';
import { EntityType } from './EntityType';
import { Match } from './Match';
import { SearchPageLink } from '../SearchPageLink';
import { useUniversalSearch } from '../useUniversalSearch';
import { SearchResultContainer, StyledLink } from './styled';
export function SearchResult() {
    const { closeSearchPopup, focusIndex, setFocusIndex, data } = useUniversalSearch();
    const { results } = data;
    return (<SearchResultContainer>
      {results.map((item, index) => (<StyledLink key={item.id} onMouseMove={() => {
                setFocusIndex(index);
            }} onMouseLeave={() => {
                setFocusIndex(null);
            }} to={getSearchEntityLink(item.entityType, item.entityId)} onClick={closeSearchPopup} $highlighted={focusIndex === index}>
          <EntityIcon type={item.entityType}/>
          <Match aria-describedby="search-dropdown-result" name={item.name} highlight={item.meta.highlight} createdAt={item.createdAt}/>
          <Box ml="auto" gap="md" alignItems="center">
            <Date aria-describedby="search-column-date" createdAt={item.createdAt}/>
            <EntityType aria-describedby="search-column-type" type={item.entityType}/>
          </Box>
        </StyledLink>))}

      <SearchPageLink />
    </SearchResultContainer>);
}
